<template>
	<div class="mirg-popup" id="mirg-popup" ref="popup" :class="{ visible, offset }" @click="close()">
		<div class="popup-close" @click="close()"></div>
		<div class="popup-text">
			<slot></slot>
		</div>
		<div class="popup-image">
			<img :src="_cdn('images/static/10kmirg@0.5x.png')" alt="mirg">
		</div>
	</div>

</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
	name: "MirgPopup",
	data() {
		return {
			visible: false,
			offset: false
		};
	},
	props: {
		id: {
			type: String,
			required: true
		},
		pushOffset: {
			type: String,
			default: '600',
		},
		pushOffsetBottom: {
			type: String,
			default: '700'
		},
	},
	methods: {
		close(): void {
			this.$cookies.set("hideMirgPopup-"+this.id, true, "1d");
			this.visible = false;
		},
		catchScroll(): void {
			const pastTopOffset = window.scrollY > parseInt(this.pushOffset);
			const pastBottomOffset =
				window.innerHeight + window.scrollY >=
				document.body.offsetHeight - parseInt(this.pushOffsetBottom);
			this.offset = parseInt(this.pushOffsetBottom) > 0
					? pastTopOffset && !pastBottomOffset && ['xs', 'sm'].includes(this.$mq)
					: pastTopOffset;
		},
	},
	mounted() {
		window.addEventListener("scroll", this.catchScroll);
		if (!this.$cookies.get("hideMirgPopup-"+this.id)) {
			setTimeout(() => (this.visible = true), 2000);
		}
	},
	destroyed() {
		window.removeEventListener("scroll", this.catchScroll);
	},
});
</script>

<style lang="scss" scoped>
.mirg-popup {
	z-index: 10;
	position: fixed;
	text-align: center;
	padding: 5px 7px;
	width: auto;
	opacity: 0;
	border-radius: 5px;
	cursor: pointer;
	background-color: rgb(232, 232, 232);
	box-shadow: 0 2px 3px #838383;

	&.visible {
		opacity: 1;
	}

	.popup-image {
		display: none;
		width: 80px;
		padding: 8px;
		margin: auto;
	}

	img {
		width: 100%;
	}

	// Left-side popup for larger screens
	@media (min-width: 1600px) {
		transition: opacity 1s ease-in-out,
						transform 1s ease-in-out;
		transform: translateY(20px);
		left: 40px;
		top: 100px;
		bottom: unset;
		width: 175px;
		box-shadow: 0 2px 3px #838383;

		&.visible {
			transform: translateY(0);
		}

		.popup-image {
			display: block;
		}
	}

	// Color theme for non-mobile devices to contrast "email this company" button
	@media (min-width: 596px) {
		color: #fff;
		background-color: #4C85BA;
		bottom: unset;
	}

	// Bottom-side popup for smaller screens
	@media (max-width: 1599px) {
		transition: opacity 200ms ease,
						transform 200ms ease;
		font-weight: bold;
		left: 50%;
		bottom: 20px;
		border: 2px solid #18416c;
		transform: translate(-50%, 30px);
		width: 90vw;
		max-width: 400px;
		font-size: 14px;

		&.visible {
			transform: translate(-50%, 0);
		}

		&.offset {
			transform: translate(-50%, -50px);
		}
	}
}
</style>
